export const RATING_CLICKABLE = 'rating-clickable';
export const RATING_NON_CLICKABLE = 'rating-non-clickable';
export const READ_REVIEW_LABEL = 'read-review-label';
export const REVIEW_NUMBER_LABEL = 'review-number-label';
export const REVIEWS_NUMBER = 'reviews-number';
export const WRITE_REVIEW_LABEL = 'write-review-label';
